import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {DatabaseNotification} from '@app/core/models/databaseNotification.model';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';

@Injectable()
export class NotificationService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(params?): DatabaseNotification {
		if (!params) {
			return new DatabaseNotification(this.httpService, this.tenantTZ, this.interService);
		}
		const notification = new DatabaseNotification(this.httpService, this.tenantTZ, this.interService).deserialize(params);
		
		return notification;
	}
}
